import { render, staticRenderFns } from "./TopPage.vue?vue&type=template&id=183fb798&scoped=true"
import script from "./TopPage.vue?vue&type=script&lang=ts"
export * from "./TopPage.vue?vue&type=script&lang=ts"
import style0 from "./TopPage.vue?vue&type=style&index=0&id=183fb798&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "183fb798",
  null
  
)

export default component.exports